import axios, { AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from 'axios';

// Create Axios instance
const api: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://rest-dot-tchrnote-remote.appspot.com/',

  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000, // 10 seconds
});

//Request interceptor to add custom headers//

api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // Ensure headers exist
    config.headers = config.headers ?? {};

    // Get auth_token from localStorage
    const authToken = localStorage.getItem('auth_token') || '';

    // Get access-token from selectedStudent
    const selectedStudentStr = localStorage.getItem('selectedStudent') || '';
    let accessToken = '';

    if (selectedStudentStr) {
      try {
        const parsedStudent = JSON.parse(selectedStudentStr);
        // Check if the student has a sessionToken property
        accessToken = parsedStudent.sessionTokenV2 || '';

        // If no sessionToken found, fallback to the regular access-token
        if (!accessToken) {
          accessToken = localStorage.getItem('access-token') || '';
        }
      } catch (err) {
        console.error('Error parsing selectedStudent:', err);
        // Fallback to regular access-token
        accessToken = localStorage.getItem('access-token') || '';
      }
    } else {
      // No selected student, use regular access-token
      accessToken = localStorage.getItem('access-token') || '';
    }

    const instance = localStorage.getItem('instance') || '';

    config.headers['access-token'] = accessToken;
    config.headers['auth_token'] = authToken;
    config.headers['instance'] = instance;
    if (accessToken) {
      config.headers['authorization'] = `Bearer ${accessToken}`;
    }
    console.log("Headers before API call:", config.headers);

    return config;
  },
  (error) => Promise.reject(error)
);





// Response interceptor for common error handling
api.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error) => {
    // Example: handle 401 globally
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('access-token');
      localStorage.removeItem('auth_token');
      localStorage.removeItem('instance');
      // Optional: redirect to login
      // window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Generic service methods
const serviceApi = {
  get: async <T = any>(url: string, params?: object): Promise<T> => {
    const response = await api.get<T>(url, { params });
    return response.data;
  },

  post: async <T = any>(url: string, data?: object): Promise<T> => {
    const response = await api.post<T>(url, data);
    return response.data;
  },

  put: async <T = any>(url: string, data?: object): Promise<T> => {
    const response = await api.put<T>(url, data);
    return response.data;
  },

  patch: async <T = any>(url: string, data?: object): Promise<T> => {
    const response = await api.patch<T>(url, data);
    return response.data;
  },

  delete: async <T = any>(url: string): Promise<T> => {
    const response = await api.delete<T>(url);
    return response.data;
  },
};

export default serviceApi;
